import { Graph } from "./Graph";
import { Node } from "./Node";
import { Edge } from "./Edge";
import { NodeTypeRegistry } from "./NodeTypeRegistry";
import { CacheSystem } from "@cook-step/cache-system";
import { NodeId, EdgeId, SocketId } from "./types";

/**
 * InternalGraph - Exposes only the necessary internals for framework use
 *
 * This class selectively exposes Graph's protected members that are needed
 * by validators and services for performance-critical operations.
 *
 * Does NOT expose internal implementation details like index maintenance methods.
 *
 * @internal
 */
export class InternalGraph extends Graph {
  // Core data structures - needed for direct access in validators
  declare public nodes: Map<NodeId, Node>;
  declare public edges: Map<EdgeId, Edge>;
  declare public registry: NodeTypeRegistry;

  // Indices - needed for performance optimization in queries
  declare public nodesByType: Map<string, Set<NodeId>>;
  declare public edgesBySource: Map<NodeId, Map<SocketId, Set<EdgeId>>>;
  declare public edgesByTarget: Map<NodeId, Map<SocketId, Set<EdgeId>>>;

  // Shared resources
  declare public cache: CacheSystem<string, any>;
  declare public metadata: Record<string, unknown>;

  // NOTE: We intentionally do NOT expose:
  // - graphQueries (use public methods instead)
  // - historyManager (internal only)
  // - populateNodeSockets (internal maintenance)
  // - addTo*Index / removeFrom*Index methods (internal maintenance)
}
